import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { Teaser } from "./Teaser";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const isConsole =
  path === "/app" ||
  path.startsWith("/app/") ||
  path === "/join" ||
  path.startsWith("/join");

createRoot(root).render(
  <StrictMode>{isConsole ? <App /> : <Teaser />}</StrictMode>,
);
